import { defineAsyncComponent } from 'vue';
import { mountVueComponent } from '@/components/mountVueComponents';

const imageMapElements = document.querySelectorAll('.js-image-map');
if (imageMapElements.length) {
  imageMapElements.forEach((imageMapElement) => {
    const imageMapComponent = defineAsyncComponent(() => import('./ImageMap.vue'));
    mountVueComponent(imageMapElement, imageMapComponent, 'ImageMap');
  });
}
